import { Injectable, signal } from '@angular/core';

export type ToastType =
  | 'success'
  | 'error'
  | 'warning'
  | 'info';

export interface ToastMessage {
  id: number;
  type: ToastType;
  message: string;
  title?: string;
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private readonly toastList = signal<ToastMessage[]>([]);

  readonly toasts = this.toastList.asReadonly();

  private nextId = 1;

  success(
    message: string,
    title = 'Éxito',
    duration = 4000
  ): void {
    this.show(
      'success',
      message,
      title,
      duration
    );
  }

  error(
    message: string,
    title = 'Error',
    duration = 5000
  ): void {
    this.show(
      'error',
      message,
      title,
      duration
    );
  }

  warning(
    message: string,
    title = 'Atención',
    duration = 4500
  ): void {
    this.show(
      'warning',
      message,
      title,
      duration
    );
  }

  info(
    message: string,
    title = 'Información',
    duration = 4000
  ): void {
    this.show(
      'info',
      message,
      title,
      duration
    );
  }

  show(
    type: ToastType,
    message: string,
    title?: string,
    duration = 4000
  ): void {
    const id = this.nextId++;

    const toast: ToastMessage = {
      id,
      type,
      message,
      title,
      duration
    };

    this.toastList.update(
      current => [...current, toast]
    );

    if (duration > 0) {
      window.setTimeout(() => {
        this.remove(id);
      }, duration);
    }
  }

  remove(id: number): void {
    this.toastList.update(
      current =>
        current.filter(
          toast => toast.id !== id
        )
    );
  }

  clear(): void {
    this.toastList.set([]);
  }
}